/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const GET_CAMPAIGN_TEMPLATE = gql`
    query GetCampaignTemplates {
        getCampaignTemplates {
            type
            updatedAt
            createdAt
            typeProps {
                title {
                    primaryTitle
                    secondaryTitle
                    text
                    textStyle {
                        color
                    }
                }
                message {
                    text
                    textStyle {
                        color
                    }
                }
                comp {
                    uri
                    resizeMode
                    posterUri
                    content
                }
                button {
                    color
                    shadowColor
                    buttonColor
                    titleColor
                    text
                    uri
                }
                footer {
                    backgroundColor
                    smallText
                    text
                }
            }
            _id
        }
    }
`;
